import {startSpinner} from "@/ts/modules/startSpinner.ts";
import ApiService from '@/ts/core/services/ApiService.ts';
import {registerPushToken} from '@/ts/modules/appPushManager.ts';


//login submit button 활성화/비활성화(단일조건)
$('form input').on('input', checkInput);

function checkInput(){
    let checkInput = $('.login_table input').val();
    
    if(checkInput === ''){
        $('.disabled_btn').removeClass('on');
        $('.disabled_btn').attr('disabled', true);
    } else {
        $('.disabled_btn').addClass('on');
        $('.disabled_btn').attr('disabled', false);
    } 
}


$(document).ready(function(){
    //emailAdress 배치
    $('.emailAddress').text(localStorage.getItem('email'));
});

$(document).ready(function() {
    let storedEmail = localStorage.getItem('email');
    if (storedEmail) {
        $('#resetpwEmail').val(storedEmail);
        $('#signupEmail').val(storedEmail);
    }
});


const API_HOST = process.env.MIX_API_HOST

const Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

//이메일 체크
$('.jobseeker_container').submit(function(event) {
    event.preventDefault();
    let data = $('.jobseeker_container').serializeJSON();

    const {spinnerContainer, stopSpinner} = startSpinner();

    ApiService.post(API_HOST + '/auth/check-email', data)
    .then(({data}) => {
        console.log(data)
        localStorage.setItem('email', $('#loginEmail').val());
        if(data.code == 200){
            window.location.replace(signinPage);
        } else if(data.code == 201) {
            window.location.replace(signupPage);
        }
    })
    .catch(({response}) => {
        console.log(response);
        let message = response.data.message;
		Toast.fire({
            text: message,
            icon: "error",
        });
    })	
    .finally(() => {
        stopSpinner(spinnerContainer);
    });
});

// 로그인
$('.signin_container').submit(async function(event) {
    event.preventDefault();
    let data = $('.signin_container').serializeJSON();

    let storedEmail = localStorage.getItem('email');

    if (storedEmail) {
        data.email = storedEmail;
    }

    if(data.remember){
        data.remember = true;
    } else{
        data.remember = false;
    }

    const {spinnerContainer, stopSpinner} = startSpinner();
    return ApiService.post('/login', data)
    .then(async({data}) => {
        
		let access_token = data.data.access_token;
		ApiService.setToken(access_token);

		// 푸시토큰 등록
		await registerPushToken();


        if(data.data.user.authed_email == null){
            localStorage.removeItem('intendedUrl')
            window.location.replace(completePage);
        } else {
            let intendedUrl = localStorage.getItem("intendedUrl");
            localStorage.removeItem('email')
            localStorage.removeItem('intendedUrl')
            window.location.replace(intendedUrl);
        }
    })
    .catch(({response}) => {
        console.log(response);
        let message = response.data.message;
		Toast.fire({
            text: message,
            icon: "error",
        });
    })	
    .finally(() => {
        stopSpinner(spinnerContainer);
    });
});

//회원가입
$('.signup_container').submit(async function(event) {
    event.preventDefault();

    let data = $('.signup_container').serializeJSON();
	let message_agree = $('.signup_container #check_4').is(':checked');

    let storedEmail = localStorage.getItem('email');
    if (storedEmail) {
        data.email = storedEmail;
    }
    data.agreed_receiving_event_messages_at = message_agree;

    const {spinnerContainer, stopSpinner} = startSpinner();

	try {
		// 첫 번째 API 요청: 회원가입
		const registerResponse = await ApiService.post(API_HOST + '/auth/register', data);
		if (registerResponse.data.code === 200) {
			let token = registerResponse.data.data.token;
			ApiService.setToken(token); // 토큰 저장

			// 두 번째 API 요청: 이메일 전송
			const emailSendResponse = await ApiService.post(API_HOST + '/auth/send-email', data);

			if (emailSendResponse.data.code === 200) {
				
				await registerPushToken(); // 푸시 토큰 등록

				
				localStorage.removeItem('intendedUrl')
				let url = new URL(completePage);
				url.searchParams.append('_access_token', token);
				window.location.replace(url.toString());
			} else {
				let message = emailSendResponse.data.message;
				Toast.fire({
					text: message,
					icon: "error",
				});
			}
		} else {
			let message = registerResponse.data.message;
			Toast.fire({
				text: message,
				icon: "error",
			});
		}
	} catch (error) {
		if (error.response) {
			let response = error.response;
			let message = response.data.message;
			Toast.fire({
				text: message,
				icon: "error",
			});
		} else {
			console.error(error);
			Swal.fire({
				text: error ,
				icon: "error",
			})
		}
        console.log(response);
        
    } finally {
        stopSpinner(spinnerContainer);
    };
});


//인증
$('.auth').submit(function(event) {
    event.preventDefault();

    let lang = document.documentElement.lang;
    let data = $('.auth').serializeJSON();

    const {spinnerContainer, stopSpinner} = startSpinner();
    axios.post(API_HOST + '/auth/authificate-code', data)
    .then(({data}) => {
        console.log(data)
        localStorage.removeItem('email')
        window.location.replace(interestsPage);
    })
    .catch(({response}) => {
        console.log(response);
        let message = response.data.message;
		Toast.fire({
            text: message,
            icon: "error",
        });
    })	
    .finally(() => {
        stopSpinner(spinnerContainer);
    });
});


//인증번호 재전송
$('.mailsend').click(function(event) {
    let data = JSON.stringify({});
    let tokenValue = localStorage.getItem('token');

    const {spinnerContainer, stopSpinner} = startSpinner();
    axios.post(API_HOST + '/auth/send-email', data)
    .then(({data}) => {
        console.log(data)
        let message = data.message;
		Toast.fire({
            text: message,
            icon: "success",
        });
    })
    .catch(({response}) => {
        console.log(response);
        let message = response.data.message;
		Toast.fire({
            text: message,
            icon: "error",
        });
    })	
    .finally(() => {
        stopSpinner(spinnerContainer);
    });
});


//비밀번호 재설정 이메일
$('.password_container').submit(function(event) {
    event.preventDefault();

    let lang = document.documentElement.lang;
    let data = $('.password_container').serializeJSON();

    const {spinnerContainer, stopSpinner} = startSpinner();
    axios.post(API_HOST + '/password/forgot-password', data)
    .then(({data}) => {
        console.log(data)
        let message = data.message;
		Toast.fire({
            text: message,
            icon: "success",
        });
    })
    .catch(({response}) => {
        console.log(response);
        let message = response.data.message;
		Toast.fire({
            text: message,
            icon: "error",
        });
    })	
    .finally(() => {
        stopSpinner(spinnerContainer);
    });
});


//비밀번호 재설정
$('.reset_container').submit(function(event) {
    event.preventDefault();

    let data = $('.reset_container').serializeJSON();

    let urlSearch = new URLSearchParams(location.search);
    let tokenValue = urlSearch.get('token')
    let requestEmail = urlSearch.get('email')

    if (requestEmail && tokenValue) {
        data.email = requestEmail;
        data.token = tokenValue;
    }
    

    const {spinnerContainer, stopSpinner} = startSpinner();
    axios.post(API_HOST + '/password/reset-password', data)
    .then(({data}) => {
        console.log(data)
        let message = data.message;
        Toast.fire({
            text: message,
            icon: "success",
            willClose: () => {
				location.href = '/';
			}
        });
    })
    .catch(({response}) => {
        console.log(response);
        let message = response.data.message;
		Toast.fire({
            text: message,
            icon: "error",
        });
    })	
    .finally(() => {
        stopSpinner(spinnerContainer);
    });
});
